import { useTranslation } from 'react-i18next'
import AppBtn, { AppBtnColor, AppBtnSize } from 'components/btn/AppBtn'
import { IOrderLinesOpenDto } from 'core/api/dto/PlanMenuControlDto'
import { useSearchParams } from 'react-router-dom'

export interface IPlanMilletProps {
  orderItem: IOrderLinesOpenDto
  setIsShowPopup: () => void
}

export const OrderLineItem = ({
  orderItem,
  setIsShowPopup,
}: IPlanMilletProps) => {
  const { t } = useTranslation()
  const [searchParams, setSearchParams] = useSearchParams()
  const currentDish = searchParams.get('dish')
  const onOrderHandler = () => {
    searchParams.set('dish', `${orderItem.id}`)
    searchParams.delete('dimension')
    searchParams.delete('index')
    setSearchParams(searchParams.toString())
  }
  return (
    <div
      className={`dish-item ${
        Number(currentDish || 0) === orderItem.id ? 'active' : ''
      }`}
      onClick={() => onOrderHandler()}
    >
      <div className="dish-item-wrap">
        <div className="flex-end">
          {!!orderItem?.countDimensionsWithDefaultMillet && (
            <div className={`status-block-item`}>
              <span>
                {t('Назначить тару')}
                {`: ${orderItem?.countDimensionsWithDefaultMillet}`}
              </span>
            </div>
          )}
        </div>
        <div
          className="time-category-wrapper"
          style={{ display: 'flex', justifyContent: 'space-between' }}
        >
          <div>
            <div className="dishes-list__title order-list__title">
              {orderItem?.dish?.name}
            </div>
          </div>
          <div>
            {!!(orderItem.dish.imagePreviewOnS3 || orderItem.dish.imagePreview) ? (
              <img
                src={orderItem.dish.imagePreviewOnS3 || orderItem.dish.imagePreview || ''}
                alt=""
                width={'60'}
                height={'60px'}
                className="img-wrap"
              />
            ) : (
              <div className="ico-wrap">
                <i className="an-ico an-ico-photo-add" />
              </div>
            )}
          </div>
        </div>
      </div>
      {Number(currentDish || 0) === orderItem.id &&
        !!orderItem?.countDimensions &&
        orderItem?.countDimensions > 0 && (
          <AppBtn
            sized={AppBtnSize.fullWidth}
            color={AppBtnColor.violetWhite}
            onClick={setIsShowPopup}
            className={'btn-millet'}
          >
            <div>
              <div>{t('Изменить тару')}</div>
              <div className="text-info-white">
                <i className="an-ico an-ico-info-circle " />
                <span>{t('Назначение для всех замеров')}</span>
              </div>
            </div>
          </AppBtn>
        )}
    </div>
  )
}
